import React from 'react'
import SucesosSubSections from '../../components/sucesosSubSections';
import { Interno, Externo, Economia, Sociedad, Cultura } from '../../assets/sucesosInfo/presidenciaAlfonsinInfo';
import Typography from '@material-ui/core/Typography'
import Link from 'gatsby-link'

const PresidenciaAlfonsinPage = () => (
  <div style={{marginTop: 10}} >
    <Typography variant="title" style={{color: '#3A3380', fontWeight: 'bold', fontSize: '1.2rem'}}>
      1983 - 1999: Una nación en la búsqueda de un proyecto común. | Sección 1 -
      {/*<Link to={'/sucesos/proyecto-radical-2'} style={{color: '#615b99', borderBottom: '2px dashed'}}> Sección 2 </Link>*/}
    </Typography>
    <SucesosSubSections info={Interno} />
    <SucesosSubSections info={Externo} />
    <SucesosSubSections info={Economia} />
    <SucesosSubSections info={Sociedad} />
    <SucesosSubSections info={Cultura} />
  </div>
)

export default PresidenciaAlfonsinPage


// WEBPACK FOOTER //
// ./src/pages/sucesos/presidencia-alfonsin.js